import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PipesModule } from '../../../pipes/pipes.module';
import { IconComponent } from '../../icon/icon.component';
import { IconButtonComponent } from '../../icon-button/icon-button.component';
import type { SlideDatePickerComponent } from '../date-picker/slide-date-picker.component';

@Component({
  selector: 'td-wb-slide-date-picker-toggle',
  templateUrl: 'slide-date-picker-toggle.component.html',
  styleUrls: ['slide-date-picker-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconButtonComponent, IconComponent, PipesModule]
})
export class SlideDatePickerToggleComponent {
  @Input('for') calendar: SlideDatePickerComponent;

  @Input()
  get disabled(): boolean {
    if (this._disabled === undefined && this.calendar !== undefined) {
      return this.calendar.disabled;
    }

    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = value;
  }

  private _disabled: boolean = false;

  toggleCalendar(): void {
    this.calendar.toggleCalendar();
  }
}
